import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectAcsCredentials } from "./state/acs.selectors";
import { filter } from "rxjs";
import { isNotNullOrUndefined } from "@pcp/core/util";

@Injectable()
export class AcsCredentialsFacade {

    private readonly store = inject(Store);

    readonly acsCredentials$ = this.store.select(selectAcsCredentials).pipe(
        filter(isNotNullOrUndefined),
    );
}
